<template>
  <div>
    <van-share-sheet
      v-model="showShare1"
      title="分享到"
      cancel-text=""
      :options="shareH5Obj.sharePlatformH5List"
      @select="onSelect"
      @click-overlay="onOverlay"
    />
    <!--弹出二维码-->
    <van-popup v-model="showQrcode" round>
      <div class="qrcode-box">
        <div class="qrcode-pic"><img :src="shareH5Obj.qrcodePic"/></div>
        <div class="qrcode-font001" v-if="shareH5Obj.qrcodeTitle">{{shareH5Obj.qrcodeTitle}}</div>
      </div>
    </van-popup>
    <!--弹出海报-->
    <van-popup v-model="showPoster" round>
      <div class="poster-box">
        <div class="poster-pic"><img :src="shareH5Obj.posterPic"/></div>
        <div class="poster-font001" v-if="shareH5Obj.posterTitle">{{shareH5Obj.posterTitle}}</div>
      </div>
    </van-popup>
    <!--微信分享弹出提示图片-->
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wechat-tips-pic" @click.stop>
        <img src="../../assets/img/guide.png"/>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import mobileType from '@/utils/mobileType';
  import browserType from '@/utils/browserType';
  import wx from 'weixin-js-sdk';
  import QRCode from 'qrcodejs2';
  import {
    getJsSdkSignature,
  } from '@/apis/activity/common';

  export default {
    props: ['showShare', 'params', 'mark', 'shareAppObj', 'shareH5Obj', 'downPic'],
    data() {
      return {
        showShare1: false,
        showQrcode: false,
        showPoster: false,
        showOverlay: false,
      };
    },
    created() {
    },
    mounted() {
    },
    watch: {
      showShare: {
        handler(val) {
          this.showShare1 = val;
        },
        deep: true
      }
    },
    methods: {
      parentDownPic(downPic) {
        if (downPic) {
          this.downloadPosterFun();
        }
      },
      onOverlay() {
        this.$emit('pushShare', !this.showShare1);
      },
      onSelect(option) {
        if (this.params.platform == 1 || this.params.platform == 2) {
          if (option.tips == '微信') {
            this.shareFriendsApp();
          } else if (option.tips == '朋友圈') {
            this.shareWechatApp();
          } else if (option.tips == '微博') {
            this.$toast(option.tips);
          } else if (option.tips == 'QQ') {
            this.$toast(option.tips);
          } else if (option.tips == '复制链接') {
            let form_tone = window.location.origin;
            let _input = document.createElement('input');   // 直接构建input
            _input.value = form_tone;  // 设置内容
            document.body.appendChild(_input);    // 添加临时实例
            _input.select();   // 选择实例内容
            document.execCommand('Copy');   // 执行复制
            document.body.removeChild(_input); // 删除临时实例
            this.$toast('已复制成功,可贴粘');
          } else if (option.tips == '下载海报') {
            this.downloadPosterFun();
            this.showPoster = !this.showPoster;
            this.showShare1 = !this.showShare1;
          } else if (option.tips == '二维码') {
            this.showQrcode = !this.showQrcode;
            this.showShare1 = !this.showShare1;
          }
          this.showShare1 = !this.showShare1;
          this.$emit('pushShare', !this.showShare1);
        } else {
          if (browserType.isWeixin()) {
            this.getJsSdkFun();
            this.$emit('pushShare', !this.showShare1);
            this.showOverlay = !this.showOverlay;
          } else {
            alert('快去下载或打开万顺叫车APP吧');
          }
        }
      },
      //APP分享到微信
      shareFriendsApp() {
        let params = {
          sharePlatformList: this.shareAppObj.shareFriend,//传多个参数给原生(为对象类型)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.wsShare.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.ws.wsShare(JSON.stringify(params));
        } else {
          alert('平台判断错误');
        }
      },
      //APP分享到微信
      shareWechatApp() {
        let params = {
          sharePlatformList: this.shareAppObj.shareWechat,//传多个参数给原生(为对象类型)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.wsShare.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.ws.wsShare(JSON.stringify(params));
        } else {
          alert('平台判断错误');
        }
      },
      //APP下载到相册
      downloadPosterFun() {
        let params = {
          sharePlatformList: this.shareAppObj.downloadPoster,//传多个参数给原生(为对象类型)
        };
        if (mobileType.isIOS()) {
          //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
          window.webkit.messageHandlers.wsShare.postMessage(params);
        } else if (mobileType.isAndroid()) {
          //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
          window.ws.wsShare(JSON.stringify(params));
        } else {
          alert('平台判断错误');
        }
      },
      // 获取JsSdk签名
      getJsSdkFun() {
        let params=this.params;
        let sharePlatformList = this.shareAppObj.shareFriend[0];
        this.$apiFun.getJsSdkSignatureFun(params,sharePlatformList);
      },
    },
  };
</script>
<style lang="less" scoped>
  .van-popup--bottom.van-popup--round {
    /*border-radius: 0;*/
  }

  .van-popup--center.van-popup--round {
    border-radius: 10px;
  }

  .qrcode-box {
    padding: 20px;

    .qrcode-pic {
      img {
        width: 300px;
        height: auto;
        display: block;
      }
    }

    .qrcode-font001 {
      text-align: center;
      padding-top: 10px;
    }
  }

  .poster-box {
    padding: 20px;

    .poster-pic {
      img {
        width: 300px;
        height: auto;
        display: block;
      }
    }

    .poster-font001 {
      text-align: center;
      padding-top: 10px;
    }
  }

  .wechat-tips-pic {
    text-align: right;
    padding-right: 1rem;
    float: right;
    width: 60%;

    img {
      width: 100%;
      height: auto;
    }
  }
</style>
